import React from 'react';
import BaseWidget from '../base-widget/BaseWidget';
import SchemaRegistry from "../../schema/registry/SchemaRegistry";

class SchemasWidget extends React.Component {

  render() {
    return (
      <BaseWidget className="SchemasWidget" title='Schemas'>
        <SchemaRegistry fields={['id', 'label', 'bound', 'updated']} showActions={false}/>
      </BaseWidget>
    );
  }
}

export default SchemasWidget;
